import { IPayment } from './payment.interface'
import { ISerie } from './serie.interface'

export interface ISubscription {
  id: number
  fund_id: number
  amount: number
  terms_and_conditions: boolean
  customer_id: string
  customer: ISubscriptionCustomer
  status: SuscriptionStatusEnum
  collector_account_prudential: any
  created_at: string
  serie: ISerie
  constancy_date: string
  payments: IPayment[]
  moneda: string
  fund: any
  payment_method: PaymentMethodEnum
  type: string
  payment_token?: string
  internal_transfer: boolean
  business_executive_fullname?: string
  scheduled_rescue?: boolean | null
  installments_number?: number
  scheduled_rescue_account_number?: string
  scheduled_rescue_cci?: string
  scheduled_rescue_bank?: string
  scheduled_rescue_status?: string
  origin?: string | null
  via?: { id: number; description: string } | null
}

export type TSubscriptionStatus = 'in progress' | 'nulled' | 'complete' | 'pending'

export enum SuscriptionStatusEnum {
  PENDING = 'PENDING',
  INPROGRESS = 'INPROGRESS',
  APPROVED = 'APPROVED',
  ANNULLED = 'ANNULLED',
  FAILED = 'FAILED',
}

export const SuscriptionStatusLabel: Record<SuscriptionStatusEnum, string> = {
  [SuscriptionStatusEnum.PENDING]: 'Pendiente',
  [SuscriptionStatusEnum.INPROGRESS]: 'En proceso',
  [SuscriptionStatusEnum.APPROVED]: 'Aprobado',
  [SuscriptionStatusEnum.ANNULLED]: 'Anulado',
  [SuscriptionStatusEnum.FAILED]: 'Fallido',
}
export enum RescueStatusEnum {
  PENDING = 'PENDING',
  INPROGRESS = 'INPROGRESS',
  APPROVED = 'APPROVED',
  ANNULLED = 'ANNULLED',
}
export enum AccountsStatusEnum {
  PENDING = 'PENDING',
  INPROGRESS = 'INPROGRESS',
  APPROVED = 'APPROVED',
  ANNULLED = 'ANULLED',
}
export enum MoneyTypeEnum {
  // TODO: mapear a PEN y USD
  PEN = 'Soles',
  USD = 'Dólares',
}
export enum MoneyTypeAccountsEnum {
  // TODO: mapear a PEN y USD
  PEN = 'Soles',
  DOL = 'Dólares',
}
export interface ISubscriptionCustomer {
  id: number
  name: string
  lastname: string
  email: string
  middlename: string
  surname: string
  channel_register?: string | null
  utm_source?: string | null
  utm_medium?: string | null
  utm_campaign?: string | null
  number_document?: string
  transac_id?: string
  numCuentaCliente?: string
  numCuentaCCICliente?: string
}

export interface ISuscription {
  data: ISubscription[]
  limit: number
  page: number
  total: number
}

interface IFund {
  id: number
  codFund: string
  title: string
}

export interface IRescueDetailResponse {
  data: IRescueDetail[]
}
export interface IRescueDetail {
  id: number
  rescue_id: number
  certificate_number: string
  request_number: string
  amount: number
  status: RescueStatusEnum
}

interface IBankAccount {
  id: number
  bank_id: number
  account_type: string
  account_number: string
  cci: string
}

export interface IRescue {
  id: number
  installments_quantity: number
  subtotal: number
  commission: number
  total: number
  customer_id: string
  fund: IFund
  details_ids: number[]
  rescue_type: string
  rescue_details: IRescueDetail[]
  serie: ISerie
  bank_account: IBankAccount
  customer: ISubscriptionCustomer
  money_type: MoneyTypeEnum
  status: RescueStatusEnum
  created_at: string
  user_account_json: UserAccountJson
  request_type: string
  internal_transfer: boolean
  constancy_date: string
  channel_register?: string | null
  origin?: string | null
  utm_source?: string | null
  utm_medium?: string | null
  utm_campaign?: string | null
}

export interface UserAccountJson {
  customer: Customer
  bank_account: IUserBankAccount
}

export interface Customer {
  id: string
  name: string
  lastname: string
  email: string
  phone_number: string
}

export interface IUserBankAccount {
  id: number
  cci: string
  bank_name: string
  money_type: string
  account_number: string
  account_type_id: number
  numCuentaCliente?: string
  numCuentaCCICliente?: string
}

export type ISelectedRescue = Partial<Pick<IRescue, 'id' | 'details_ids' | 'status'>>

export enum PaymentMethodEnum {
  TRANSFER = 'TRANSFER',
  ONLINE = 'ONLINE',
}

export const PaymentMethodMap = {
  [PaymentMethodEnum.TRANSFER]: 'Tradicional',
  [PaymentMethodEnum.ONLINE]: 'FLOID',
}
